import React from 'react';
import { Accordion, AccordionHeader, AccordionBody, Typography, } from '@one-thd/sui-atomic-components';
export var StepThree = function () {
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var handleChange = function (event, isExpanded) {
        setExpanded(isExpanded);
    };
    return (React.createElement("div", { "data-testid": "upload-instructions-step3" },
        React.createElement("div", { className: "sui-flex sui-mb-2" },
            React.createElement("div", { className: "sui-min-w-[60px] sui-text-lg" },
                React.createElement(Typography, { weight: "bold" }, "Step 3:")),
            React.createElement(Typography, null, "Save the spreadsheet as a CSV file.")),
        React.createElement("div", { className: "sui-mb-8" },
            React.createElement(Accordion, { expanded: expanded, onChange: handleChange },
                React.createElement(AccordionHeader, null, "How to save a CSV file"),
                React.createElement("div", { className: "sui-border-solid sui-border-1 sui-border-primary sui-border-t-0" },
                    React.createElement(AccordionBody, null,
                        React.createElement("div", { className: "sui-text-base" },
                            React.createElement("div", { className: "sui-mb-3" },
                                React.createElement("div", { className: " sui-mb-2" },
                                    React.createElement(Typography, { weight: "bold" }, "If using Excel")),
                                React.createElement("ol", { className: "sui-list-decimal sui-ml-5" },
                                    React.createElement("li", null,
                                        React.createElement(Typography, null,
                                            "Select",
                                            ' ',
                                            React.createElement(Typography, { component: "span", weight: "bold" }, "File"))),
                                    React.createElement("li", null,
                                        React.createElement(Typography, null,
                                            "Choose",
                                            ' ',
                                            React.createElement(Typography, { component: "span", weight: "bold" }, "Save As"))),
                                    React.createElement("li", null,
                                        React.createElement(Typography, null, "Select \"CSV UTF-8 (Comma delimited) (.csv)\"")))),
                            React.createElement("div", { className: "sui-mb-3" },
                                React.createElement("div", { className: "sui-mb-2" },
                                    React.createElement(Typography, { weight: "bold" }, "If using Google Docs")),
                                React.createElement("ol", { className: "sui-list-decimal sui-ml-5" },
                                    React.createElement("li", null,
                                        React.createElement(Typography, null,
                                            "Select",
                                            ' ',
                                            React.createElement(Typography, { component: "span", weight: "bold" }, "File"))),
                                    React.createElement("li", null,
                                        React.createElement(Typography, null,
                                            "Choose",
                                            ' ',
                                            React.createElement(Typography, { component: "span", weight: "bold" }, "Download"))),
                                    React.createElement("li", null,
                                        React.createElement(Typography, null, "Select \"Comma Separated Values (.csv)\"")))),
                            React.createElement("div", { className: "sui-mb-2" },
                                React.createElement(Typography, { weight: "bold" }, "If using Numbers (MacOS)")),
                            React.createElement("ol", { className: "sui-list-decimal sui-ml-5" },
                                React.createElement("li", null,
                                    React.createElement(Typography, null,
                                        "Select",
                                        ' ',
                                        React.createElement(Typography, { component: "span", weight: "bold" }, "File"))),
                                React.createElement("li", null,
                                    React.createElement(Typography, null,
                                        "Choose",
                                        ' ',
                                        React.createElement(Typography, { component: "span", weight: "bold" }, "Export To"))),
                                React.createElement("li", null,
                                    React.createElement(Typography, null, "Select \"CSV\""))))))))));
};
